/* State Imports */

import StateInterface from "../state-interface";

/* Category Default State Data */

const transaction_type: StateInterface["transaction"] = "buy";

export const transaction = transaction_type;
export default transaction_type;
